import { imageUrl } from './createThemeAssets'

const rgba = (rgb, alpha) => `rgba(${rgb}, ${alpha})`

export function createColorThemeConfig({ name, label, assets, palette }) {
    const p = palette

    return {
        name,
        label,
        assets,
        cssVars: {
            '--theme-root-bg': p.deep,
            '--theme-page-bg': [
                imageUrl(assets.home.pageBg),
                `radial-gradient(circle at 50% 0, ${rgba(p.glowRgb, '.2')} 0, ${rgba(p.glowRgb, '0')} 42%)`,
                `linear-gradient(180deg, ${rgba(p.mainRgb, '.5')} 0%, ${rgba(p.deepRgb, '.78')} 100%)`
            ].join(','),
            '--theme-page-bg-size': 'cover, 100% 7.2rem, 100% 100%',
            '--theme-page-bg-position': 'center top, center top, center top',
            '--theme-header-bg': `linear-gradient(180deg, ${rgba(p.mainRgb, '.96')} 0%, ${rgba(p.midRgb, '.9')} 100%)`,
            '--theme-header-control-bg': p.control,
            '--theme-header-control-border': p.border,
            '--theme-header-control-border-gradient': `linear-gradient(180deg, ${rgba(p.glowRgb, '.38')}, ${p.border})`,
            '--theme-header-accent-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-surface-bg': rgba(p.surfaceRgb, '.54'),
            '--theme-surface-border': p.border,
            '--theme-soft-text': p.softText,
            '--theme-bright-text': p.brightText,
            '--theme-input-bg': p.control,
            '--theme-input-border': p.border,
            '--theme-input-focus-bg': p.focus,
            '--theme-input-focus-border': p.accentLight,
            '--theme-input-focus-border-rgb': p.glowRgb,
            '--theme-input-placeholder': rgba(p.softTextRgb, '.68'),
            '--theme-list-bg': rgba(p.deepRgb, '.28'),
            '--theme-list-header-bg': rgba(p.mainRgb, '.86'),
            '--theme-list-row-border': rgba(p.brightRgb, '.2'),
            '--theme-active-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-active-text': '#ffffff',
            '--theme-gold-bg': 'linear-gradient(180deg, #FFD426 0%, #FF7E13 100%)',
            '--theme-gold-text': '#290000',
            '--theme-banner-bg': imageUrl(assets.home.bannerBg),
            '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
            '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
            '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
            '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
            '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
            '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
            '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
            '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
            '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
            '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
            '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
            '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
            '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
            '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
            '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
            '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
            '--theme-home-classify-fixed-bg': `linear-gradient(180deg, ${rgba(p.brightRgb, '.04')} 0%, ${rgba(p.brightRgb, '0')} .16rem), linear-gradient(180deg, ${rgba(p.midRgb, '.98')} 0%, ${rgba(p.deepRgb, '.98')} 100%)`,
            '--theme-home-classify-item-bg': `radial-gradient(circle at 12% 0, ${rgba(p.glowRgb, '.2')} 0, ${rgba(p.glowRgb, '0')} 26%), linear-gradient(180deg, ${rgba(p.brightRgb, '.1')} 0%, ${rgba(p.brightRgb, '0')} .1rem), linear-gradient(180deg, ${rgba(p.mainRgb, '.96')} 0%, ${rgba(p.midRgb, '.99')} 100%)`,
            '--theme-home-classify-icon-bg': p.iconBg,
            '--theme-home-classify-nav-bg': `linear-gradient(180deg, ${rgba(p.brightRgb, '.12')} 0%, ${rgba(p.brightRgb, '0')} .12rem), linear-gradient(180deg, ${rgba(p.mainRgb, '.96')} 0%, ${rgba(p.midRgb, '.99')} 100%)`,
            '--theme-home-classify-nav-border': rgba(p.brightRgb, '.18'),
            '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(255, 255, 255, .08), 0 .04rem .1rem rgba(4, 16, 34, .16)',
            '--theme-home-banner-panel-bg': `linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .02), ${rgba(p.midRgb, '.5')})`,
            '--theme-home-section-top-bg': `linear-gradient(180deg, ${rgba(p.surfaceRgb, '.66')} 0%, ${rgba(p.surfaceRgb, '0')} 100%)`,
            '--theme-home-notice-line-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-home-notice-item-bg': `linear-gradient(-90deg, ${rgba(p.surfaceRgb, '0')} 0%, ${rgba(p.surfaceRgb, '.82')} 100%)`,
            '--theme-home-notice-icon-filter': p.noticeIconFilter,
            '--theme-game-placeholder-surface': `linear-gradient(180deg, ${rgba(p.mainRgb, '.94')} 0%, ${rgba(p.midRgb, '.99')} 100%)`,
            '--theme-game-placeholder-skeleton': `linear-gradient(110deg, ${rgba(p.brightRgb, '0')} 30%, ${rgba(p.glowRgb, '.22')} 50%, ${rgba(p.brightRgb, '0')} 70%), linear-gradient(180deg, ${rgba(p.surfaceRgb, '.58')} 0%, ${rgba(p.deepRgb, '.94')} 100%)`,
            '--theme-game-placeholder-fallback': `radial-gradient(circle at 50% 18%, ${rgba(p.glowRgb, '.18')} 0%, ${rgba(p.glowRgb, '0')} 36%), linear-gradient(180deg, ${rgba(p.surfaceRgb, '.94')} 0%, ${rgba(p.deepRgb, '.99')} 100%)`,
            '--theme-game-placeholder-border': rgba(p.brightRgb, '.14'),
            '--theme-game-title-bg': `linear-gradient(180deg, ${rgba(p.midRgb, '.72')} 0%, ${rgba(p.deepRgb, '.9')} 100%)`,
            '--theme-game-title-text': p.softText,
            '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
            '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
            '--theme-footer-title-text': p.brightText,
            '--theme-footer-body-text': p.softText,
            '--theme-footer-muted-text': rgba(p.brightRgb, '.86'),
            '--theme-footer-copyright-text': p.brightText,
            '--theme-footer-menu-title-bg': `linear-gradient(90deg, ${rgba(p.mainRgb, '.92')} 0%, ${rgba(p.deepRgb, '.08')} 100%)`,
            '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
            '--theme-footer-menu-list-bg': `linear-gradient(90deg, ${rgba(p.midRgb, '.64')} 0%, ${rgba(p.deepRgb, '.12')} 100%)`,
            '--theme-footer-menu-link-text': p.brightText,
            '--theme-home-banner-html-text': p.softText,
            '--theme-share-bg-top': imageUrl(assets.share.bgTop),
            '--theme-share-bg': imageUrl(assets.share.shareBg),
            '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
            '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
            '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
            '--theme-vip-membership-emblem': imageUrl(assets.person.membershipEmblem),
            '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
            '--theme-event-top-bg': imageUrl(assets.event.topBg),
            '--theme-event-top-right': imageUrl(assets.event.topRight),
            '--theme-event-detail-text': p.softText,
            '--theme-event-card-bg': rgba(p.surfaceRgb, '.54'),
            '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
            '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
            '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
            '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
            '--theme-signin-accent-text': '#FF8400',
            '--theme-signin-accent-border': p.accentLight,
            '--theme-signin-progress-line': p.accent,
            '--theme-signin-disabled-btn-bg': 'linear-gradient(180deg, rgba(142, 164, 185, .96) 0%, rgba(87, 105, 126, .98) 100%)',
            '--theme-signin-disabled-btn-text': '#e8f4ff',
            '--theme-signin-day-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-signin-day-border': p.softText,
            '--theme-signin-unlocked-bg': `linear-gradient(180deg, ${p.glow} 0%, ${p.accent} 99.29%)`,
            '--theme-signin-secondary-amount-text': p.glow,
            '--theme-signin-nav-btn-bg': rgba(p.brightRgb, '.18'),
            '--theme-signin-active-icon-shadow': `0px 2px 4px 0px ${rgba(p.deepRgb, '.55')}`,
            '--theme-frame-line-vertical': `linear-gradient(to bottom, transparent 0%, ${p.accent} 10%, ${p.accentLight} 50%, ${p.accent} 85%, transparent 100%)`,
            '--theme-frame-line-horizontal': `linear-gradient(to right, transparent 0%, ${p.border} 15%, ${p.accentLight} 50%, ${p.border} 85%, transparent 100%)`,
            '--theme-tabbar-shell-bg': p.accent,
            '--theme-tabbar-text': 'rgba(255, 255, 255, .68)',
            '--theme-tabbar-active-text': '#ffffff',
            '--theme-tabbar-float-bg': `linear-gradient(180deg, ${rgba(p.deepRgb, '.96')} 0%, ${rgba(p.mainRgb, '.98')} 100%)`,
            '--theme-tabbar-divider': rgba(p.glowRgb, '.2'),
            '--theme-tabbar-active-bg': [
                imageUrl(assets.tabbar.activeBorders[0]),
                imageUrl(assets.tabbar.activeBorders[1]),
                imageUrl(assets.tabbar.activeBorders[2]),
                imageUrl(assets.tabbar.activeBorders[3]),
                `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`
            ].join(','),
            '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
            '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
            '--theme-popup-bg': `linear-gradient(180deg, ${p.mid} 0%, ${p.main} 100%)`,
            '--theme-popup-overlay-bg': rgba(p.deepRgb, '.72'),
            '--theme-popup-close-bg': p.control,
            '--theme-popup-close-border': p.border,
            '--theme-popup-panel-bg': rgba(p.surfaceRgb, '.54'),
            '--theme-popup-panel-fill': p.focus,
            '--theme-popup-panel-border': `linear-gradient(180deg, ${rgba(p.glowRgb, '.35')}, ${rgba(p.glowRgb, '.18')})`,
            '--theme-popup-panel-shadow': `inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .16), inset -.16rem -.16rem .58rem 0 ${rgba(p.glowRgb, '.12')}`,
            '--theme-panel-strong-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-card-strong-bg': `linear-gradient(180deg, ${p.main} 0%, ${p.mid} 100%)`,
            '--theme-card-strong-border': p.border,
            '--theme-popup-tabs-bg': rgba(p.mainRgb, '.82'),
            '--theme-popup-mask-bg': rgba(p.midRgb, '.52'),
            '--theme-popup-box-bg': rgba(p.surfaceRgb, '.92'),
            '--theme-popup-box-border': p.border,
            '--theme-popup-box-shadow': `inset 0 0 .1rem 0 ${rgba(p.glowRgb, '.48')}`,
            '--theme-popup-amount-text': '#FFD426',
            '--theme-sidebar-bg': [
                `linear-gradient(180deg, ${rgba(p.mainRgb, '.96')} 0%, ${rgba(p.deepRgb, '.98')} 100%)`,
                imageUrl(assets.home.pageBg)
            ].join(','),
            '--theme-sidebar-bg-size': '100% 100%, cover',
            '--theme-sidebar-border': rgba(p.glowRgb, '.24'),
            '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
            '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
            '--theme-sidebar-item-text': p.softText,
            '--theme-sidebar-item-active-bg': `linear-gradient(-90deg, ${rgba(p.surfaceRgb, '0')} 0%, ${p.accentLight} 100%)`,
            '--theme-sidebar-item-active-line': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-sidebar-control-bg': p.control,
            '--theme-sidebar-control-border': p.border,
            '--theme-sidebar-service-bg': `linear-gradient(180deg, ${p.accentLight} 0%, ${p.accent} 100%)`,
            '--theme-sidebar-drawer-mask-bg': rgba(p.midRgb, '.58')
        }
    }
}
